import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { trackHelpCenterSwitchGuideClick } from "@faire/web-api--source/events/helpCenter/click/switchGuide";
import brands from "@faire/web-api--source/routes/support/brands";
import retailers from "@faire/web-api--source/routes/support/retailers";
import React, { type JSX } from "react";
import styled from "styled-components";

interface IProps {
  isBrandPath: boolean;
}

export const BrandRetailerMutualLink: React.FC<IProps> = ({ isBrandPath }) => {
  return (
    <Typography color={Core.text.subdued}>
      {isBrandPath ? <LinkToRetailers /> : <LinkToBrands />}
    </Typography>
  );
};

const LinkToRetailers: React.FC = () => (
  <StrictLocalMsg
    defaultMessage="Not a brand? <LinkFormatting>Switch to Retailer Guides</LinkFormatting>"
    values={{
      LinkFormatting: MutualLinkToRetailers,
    }}
  />
);

const LinkToBrands: React.FC = () => (
  <StrictLocalMsg
    defaultMessage="Not a retailer? <LinkFormatting>Switch to Brand Guides</LinkFormatting>"
    values={{
      LinkFormatting: MutualLinkToBrands,
    }}
  />
);

const MutualLinkToRetailers = (chunks: JSX.Element) => (
  <MutualLink
    data-test-id="switch-to-retailer-link"
    to={retailers()}
    onClick={() => trackHelpCenterSwitchGuideClick("retailer")}
  >
    {chunks}
  </MutualLink>
);

const MutualLinkToBrands = (chunks: JSX.Element) => (
  <MutualLink
    data-test-id="switch-to-brand-link"
    to={brands()}
    onClick={() => trackHelpCenterSwitchGuideClick("brand")}
  >
    {chunks}
  </MutualLink>
);

const MutualLink = styled(Link)`
  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    left: 0px;
    bottom: -2px;
    width: 100%;
    height: 1px;
    background-color: ${Core.surface
      .disabled}; // TODO replace with non-disabled surface token
  }
`;
